import API from './api';

export const initializeEvaluation = (session) =>
  API.post('/aichatbot/evaluation_reviews/initialize/', { session }).then(
    (response) => response.data,
  );

export const getEvaluationReviews = (params = {}, options = {}) =>
  API.get('/aichatbot/evaluation_reviews/', { params, signal: options.signal }).then(
    (response) => response.data,
  );

export const getAllEvaluationReviews = async (params = {}) => {
  const { signal, ...queryParams } = params;
  const pageSize = 100;
  const firstPage = await getEvaluationReviews({
    ...queryParams,
    page: 1,
    page_size: pageSize,
  }, { signal });
  if (Array.isArray(firstPage)) return firstPage;

  const results = firstPage?.results || [];
  const pageCount = Math.ceil((firstPage?.count || results.length) / pageSize);
  if (pageCount <= 1) return results;

  const remainingPages = await Promise.all(
    Array.from({ length: pageCount - 1 }, (_, index) =>
      getEvaluationReviews({
        ...queryParams,
        page: index + 2,
        page_size: pageSize,
      }, { signal }),
    ),
  );
  return remainingPages.reduce(
    (all, page) => all.concat(page?.results || page || []),
    results,
  );
};

export const getEvaluationReview = (uuid) =>
  API.get(`/aichatbot/evaluation_reviews/${uuid}/`).then(
    (response) => response.data,
  );

export const saveReviewAnnotation = (reviewUuid, payload) =>
  API.put(
    `/aichatbot/evaluation_reviews/${reviewUuid}/annotation/`,
    payload,
  ).then((response) => response.data);

export const regenerateEvaluation = (reviewUuid, payload) =>
  API.post(
    `/aichatbot/evaluation_reviews/${reviewUuid}/regenerate/`,
    payload,
  ).then((response) => response.data);

export const approveEvaluation = (reviewUuid, payload) =>
  API.post(
    `/aichatbot/evaluation_reviews/${reviewUuid}/approve/`,
    payload,
  ).then((response) => response.data);

export const getExperts = () =>
  API.get('/auth/experts/').then((response) => response.data);

export const createExpert = (payload) =>
  API.post('/auth/experts/', payload).then((response) => response.data);

export const resendExpertInvitation = (uuid) =>
  API.post(`/auth/experts/${uuid}/resend_invitation/`).then(
    (response) => response.data,
  );

export const deactivateExpert = (uuid) =>
  API.post(`/auth/experts/${uuid}/deactivate/`).then(
    (response) => response.data,
  );

export const createExpertAssignment = (payload) =>
  API.post('/auth/expert_assignments/', payload).then(
    (response) => response.data,
  );

export const deleteExpertAssignment = (uuid) =>
  API.delete(`/auth/expert_assignments/${uuid}/`);

export const acceptExpertInvitation = (token, password) =>
  API.post(`/auth/expert_invitation/${token}/`, { password }).then(
    (response) => response.data,
  );
